import { useState } from 'react';

import {
  ContainerEngine,
  Environment,
} from '@/react/portainer/environments/types';
import {
  commandsTabs,
  CommandTab,
} from '@/react/edge/components/EdgeScriptForm/scripts';
import { Platform } from '@/react/edge/components/EdgeScriptForm/types';
import { isBE } from '@/react/portainer/feature-flags/feature-flags.service';
import EdgeAgentStandardIcon from '@/react/edge/components/edge-agent-standard.svg?c';
import EdgeAgentAsyncIcon from '@/react/edge/components/edge-agent-async.svg?c';

import { BoxSelector } from '@@/BoxSelector';
import { BoxSelectorOption } from '@@/BoxSelector/types';

import { AnalyticsStateKey } from '../types';
import { EdgeAgentTab } from '../shared/EdgeAgentTab';

interface Props {
  onCreate(environment: Environment, analytics: AnalyticsStateKey): void;
}

type CreationType = 'edgeAgentStandard' | 'edgeAgentAsync';

const options: BoxSelectorOption<CreationType>[] = [
  {
    id: 'edgeAgentStandard',
    icon: EdgeAgentStandardIcon,
    iconType: 'badge',
    label: 'Edge Agent Standard',
    description:
      'The remote environment will initiate connections to the Portainer server, with the ability to open a secure on-demand tunnel for real-time interaction. The Portainer server must be accessible from the Edge Agent environment.',
    value: 'edgeAgentStandard',
  },
  ...(isBE
    ? [
        {
          id: 'edgeAgentAsync',
          icon: EdgeAgentAsyncIcon,
          iconType: 'badge' as const,
          label: 'Edge Agent Async',
          description:
            'The remote environment will initiate connections to the Portainer server, without the ability to open a real-time tunnel. The Portainer server must be accessible from the Edge Agent environment.',
          value: 'edgeAgentAsync' as const,
        },
      ]
    : []),
];

const kubesoloCommands: CommandTab[] = [
  commandsTabs.kubesoloLinux,
  {
    ...commandsTabs.k8sLinux,
    id: 'standalone' as Platform,
    label: 'Manual',
  },
];

export function WizardKubesolo({ onCreate }: Props) {
  const [creationType, setCreationType] =
    useState<CreationType>('edgeAgentStandard');

  return (
    <div className="form-horizontal">
      <BoxSelector
        onChange={(v) => setCreationType(v)}
        options={options}
        value={creationType}
        radioName="creation-type"
      />

      {creationType === 'edgeAgentStandard' && (
        <EdgeAgentTab
          onCreate={(environment) =>
            onCreate(environment, 'kubesoloEdgeAgentStandard')
          }
          commands={kubesoloCommands}
          containerEngine={ContainerEngine.Kubernetes}
        />
      )}

      {creationType === 'edgeAgentAsync' && (
        <EdgeAgentTab
          asyncMode
          onCreate={(environment) =>
            onCreate(environment, 'kubesoloEdgeAgentAsync')
          }
          commands={kubesoloCommands}
          containerEngine={ContainerEngine.Kubernetes}
        />
      )}
    </div>
  );
}
